import RemoveInviteLink from './RemoveInviteLink'

export default RemoveInviteLink
